import React, { useState } from 'react';
import { Button, Grid } from "@material-ui/core";

import NewShipBoxDialog from "./NewShipBoxDialog"
import ShipBoxTable from "./ShipBoxTable"

export default function ShipBox() {
  const [creatingBox, setCreatingBox] = useState(false);

  return (
    <Grid container spacing={2}>
      <Grid item xs={10}></Grid>
      <Grid item xs={2}>
        <Button variant="outlined" onClick={() => setCreatingBox(true)}>Create New Box</Button>
      </Grid>
      <Grid item xs={12}>
        <ShipBoxTable/>
      </Grid>

      <NewShipBoxDialog creatingBox={creatingBox} setCreatingBox={setCreatingBox}/>
    </Grid>
  );
}
